// @flow

import { get, isUndefined } from "lodash"
import type { Price, TripStatus } from "shared/types/OrdersType"
import pendingIcon from "apps/orders/icons/status/pending.svg"
import completedIcon from "apps/orders/icons/status/completed.svg"
import droppedOffIcon from "apps/orders/icons/status/dropped_off.svg"
import enRouteIcon from "apps/orders/icons/status/en_route.svg"
import inVehicleIcon from "apps/orders/icons/status/in_vehicle.svg"
import invalidNoShowIcon from "apps/orders/icons/status/invalid_no_show.svg"
import noShowIcon from "apps/orders/icons/status/no_show.svg"
import cancelledIcon from "apps/orders/icons/status/cancelled.svg"
import cancelledAtDoorIcon from "apps/orders/icons/status/cancelled_at_door.svg"
import unknownIcon from "apps/orders/icons/status/unknown.svg"
import failedIcon from "apps/orders/icons/status/failed.svg"
import externalIcon from "apps/orders/icons/status/external.svg"
import type { Address } from "shared/types/OrdersType"
import { toTitleCase } from "shared/utils/stringUtils"

class OrderSearchUtils {
  renderStatusIcon = (status: TripStatus) => {
    let statusIcon
    switch (status) {
      case "PENDING":
        statusIcon = pendingIcon
        break
      case "COMPLETED":
        statusIcon = completedIcon
        break
      case "DROPPED_OFF":
        statusIcon = droppedOffIcon
        break
      case "EN_ROUTE":
        statusIcon = enRouteIcon
        break
      case "IN_VEHICLE":
        statusIcon = inVehicleIcon
        break
      case "NO_SHOW":
        statusIcon = noShowIcon
        break
      case "INVALID_NO_SHOW":
        statusIcon = invalidNoShowIcon
        break
      case "CANCELLED":
        statusIcon = cancelledIcon
        break
      case "CANCELLED_AT_DOOR":
        statusIcon = cancelledAtDoorIcon
        break
      case "UNKNOWN":
        statusIcon = unknownIcon
        break
      case "FAILED":
        statusIcon = failedIcon
        break
      case "EXTERNAL":
        statusIcon = externalIcon
        break
    }
    return statusIcon
  }

  orderReferenceMap = new Map<string, string>([
    ["CABONLINE:CABFROGNE", "CabFrogne"],
    ["FROGNE:CABFROGNE", "CabFrogne"],
    ["CABONLINE:XAP", "XAP"],
    ["FROGNE:norges-taxi", "Norgestaxi"],
    ["FROGNE:sverigetaxi", "Sverigetaxi"],
    ["FROGNE:taxi-kurir", "Taxi Kurir"],
    ["FROGNE:taxi-kurir-stockholm", "Taxi Kurir Stockholm"],
    ["SCHOOL_TRAVELER", "School trip"],
    ["TAXISYSTEM:tsysdb03.taxi_skane", "Taxisystem Taxi Skåne"],
    ["tsys_harnosand_001:orderId", "Taxisystem Härnösand"],
    ["tsys_sundsvall_001:orderId", "Taxisystem Sundsvall"]
  ])

  resolveExternalRefPrettyName = (ref: string) => {
    return !isUndefined(this.orderReferenceMap.get(ref))
      ? this.orderReferenceMap.get(ref)
      : ref
  }

  isOrderReference = (ref: string) => {
    return this.orderReferenceMap.has(ref)
  }

  addressObjToText = (address: Address, detailed: boolean = false) => {
    const street = get(address, "street")
    const streetNumber = get(address, "streetNumber")
    const placeName = get(address, "placeName")
    const city = get(address, "city")

    const fullStreet = [street, streetNumber].filter(Boolean).join(" ")

    if (placeName && !detailed) {
      return toTitleCase([placeName, city].filter(Boolean).join(", "))
    }

    return toTitleCase([placeName, fullStreet, city].filter(Boolean).join(", "))
  }

  priceObjToText = (price: Price) => {
    const amount = get(price, "amount")
    return !isUndefined(amount) ? amount + " " + get(price, "currency") : "-"
  }
}

export default (new OrderSearchUtils(): any)
